import { render } from "./attribute_xx.vue?vue&type=template&id=6a3f5e1a&scoped=true"
import script from "./attribute_xx.vue?vue&type=script&lang=js"
export * from "./attribute_xx.vue?vue&type=script&lang=js"

import "./attribute_xx.vue?vue&type=style&index=0&id=6a3f5e1a&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3f5e1a"]])

export default __exports__